/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import classNames from "classnames";

import styles from "./SpeakingRipple.module.css";

interface Props {
  /** Whether to show the rings as actively pulsing (someone is speaking). */
  speaking: boolean;
  className?: string;
}

/**
 * Three concentric rings around whatever is centered inside this component's
 * parent, pulsing when `speaking` is true. Used by the dedicated audio-only
 * call view; conceptually the same "ripple" idea as MediaView's speaking
 * waves, but drawn as stroke-only navy rings at fixed proportions rather than
 * MediaView's filled gray waves sized relative to a video tile.
 */
export const SpeakingRipple: FC<Props> = ({ speaking, className }) => (
  <div
    className={classNames(styles.ripple, className)}
    data-speaking={speaking}
    aria-hidden
  >
    <div className={styles.ring} data-ring="1" />
    <div className={styles.ring} data-ring="2" />
    <div className={styles.ring} data-ring="3" />
  </div>
);
